import React from 'react';
import { Box, Inscription, NavigationLeftIcon } from '@common-fe/common-fe';

import { stepsWithHealthPlans } from '../RenewalSetup';
import { RenewalSetupStep, RenewalSetupStepTitle } from '../RenewalSetup.types';

interface Props {
  currentStep: RenewalSetupStep;
  steps?: RenewalSetupStep[];
  handleStepName: (stepName: RenewalSetupStep) => void;
}

const NavigationBackButton: React.FC<Props> = ({
  currentStep,
  steps = stepsWithHealthPlans,
  handleStepName,
}) => (
  <Box margin={{ bottom: 'l' }}>
    <Box direction="row" align="center" onClick={() => handleStepName(steps[steps.indexOf(currentStep) - 1])}>
      <NavigationLeftIcon size="24px" color="iconAccent" />
      <Inscription color="textAccent" margin={{ left: 'xxs' }}>
        Back to{' '}
        {RenewalSetupStepTitle[steps[steps.indexOf(currentStep) - 1] as keyof typeof RenewalSetupStepTitle]}
      </Inscription>
    </Box>
  </Box>
);

export default NavigationBackButton;
